import React from 'react';
import { Redirect } from 'react-router-dom';
import securityService from '../../security/security';
import NoMatch from 'src/screens/NoMatch';
import history from 'src/navigation/history';
import * as H from 'history';
import UserAuthService from 'src/services/user-auth';
import routes from '../../navigation/routes';
import user from '../../services/user-auth';
import UserRole from '../../enumerables/user-role';
const Restricted = ({
    children,
    authParams,
    redirectTo,
}: {
    children: any;
    authParams?: { action: string; subject?: any } | null;
    redirectTo?: string;
}) => {
    //console.log('redirectTo', redirectTo);
    //console.log('window.location', window.location);
    // console.log('authParams', authParams);
    //console.log('history', history.location.pathname);

    if (authParams && !securityService.isGranted(authParams.action, authParams.subject)) {
        let toPath: H.LocationDescriptor = {
            pathname: redirectTo,
            state: { backUrl: history?.location?.pathname },
        };

        if (user.getRoles().includes(UserRole.ROLE_USER)) {
            toPath = {
                pathname: redirectTo,
                state: {},
            };
        }
        if (history?.location?.pathname === routes.LOGIN_CUSTOMER) {
            toPath = {
                pathname: redirectTo,
                state: {},
            };
        }

        UserAuthService.logout();
        return redirectTo ? <Redirect to={toPath} /> : <NoMatch code={403} message="No access" />;
    } else {
        return children;
    }
};

export default Restricted;
